export enum TipoTentativaEnum {
    IA = 0,
    COB = 1,
    TE = 2
}
